import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const base = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/$/, '');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setSubmitting(true);
    try {
      const { data } = await axios.post<{ success?: boolean; message?: string }>(
        `${base}/auth/forgot-password`,
        { email: email.trim() },
        { headers: { 'Content-Type': 'application/json' } },
      );
      setMessage(data.message || 'If an account exists for this email, you will receive instructions shortly.');
    } catch (err: unknown) {
      const msg =
        axios.isAxiosError(err) && err.response?.data && typeof err.response.data === 'object'
          ? String((err.response.data as { error?: string }).error || 'Request failed')
          : 'Request failed';
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="hero-background"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        fontFamily: 'var(--font-family)',
      }}
    >
      <div
        className="card"
        style={{
          textAlign: 'center',
          maxWidth: 400,
          width: '90%',
          padding: '48px 32px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          border: '1px solid rgba(255,255,255,0.2)',
          borderRadius: 12,
        }}
      >
        <h1 style={{ marginBottom: 8, color: 'var(--secondary-color)' }}>Forgot password</h1>
        <p style={{ color: '#6c757d', marginBottom: 24, textAlign: 'left', fontSize: '0.95rem' }}>
          Enter the email for your local account. If it exists, we will send a reset link.
        </p>

        {message && (
          <p style={{ color: '#155724', background: '#d4edda', padding: 12, borderRadius: 8, marginBottom: 16 }}>
            {message}
          </p>
        )}
        {error && (
          <p style={{ color: '#721c24', background: '#f8d7da', padding: 12, borderRadius: 8, marginBottom: 16 }}>
            {error}
          </p>
        )}

        {!message && (
          <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
            <label
              htmlFor="forgot-email"
              style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: 'var(--secondary-color)' }}
            >
              Email
            </label>
            <input
              id="forgot-email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: 12,
                borderRadius: 8,
                border: '1px solid #ced4da',
                fontSize: '1rem',
                boxSizing: 'border-box',
                marginBottom: 24,
              }}
            />
            <button
              type="submit"
              disabled={submitting}
              style={{
                width: '100%',
                padding: '16px 24px',
                fontSize: '1.1rem',
                fontWeight: 600,
                cursor: submitting ? 'not-allowed' : 'pointer',
                opacity: submitting ? 0.6 : 1,
                border: '1px solid #FC5003',
                color: '#FC5003',
                background: 'transparent',
                borderRadius: 8,
              }}
            >
              {submitting ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        <Link
          to="/login"
          style={{ display: 'inline-block', marginTop: 24, color: '#6c757d', fontSize: '0.95rem' }}
        >
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
